export default {
  AGUARDANDO_APROVACAO: 'AGUARDANDO_APROVACAO',
  CREDENCIADO: 'CREDENCIADO',
  REJEITADO: 'REJEITADO',
  ATIVO: 'ATIVO',
  INATIVO: 'INATIVO',
  RETIFICADO: 'RETIFICADO',
  REPROVADO: 'REJEITADO',
  APROVADO: 'CREDENCIADO',
  AGUARDANDO_VALIDACAO: 'AGUARDANDO_VALIDACAO'
}

export const SITUACOES_FORMATADAS = {
  AGUARDANDO_APROVACAO: 'Aguardando Análise',
  APROVADO: 'Aprovado',
  REPROVADO: 'Reprovado',
  CREDENCIADO: 'Credenciado',
  REJEITADO: 'Reprovado',
  RETIFICADO: 'Aguardando Retificação',
  AGUARDANDO_VALIDACAO: 'Aguardando Validação'
}
